import React from "react";
import "./service.css";

import serviceimg from "../../assets/service.jpg";

import ScrollReveal from "../ScrollReveal";
import Scrolllefteffect from "../Scrolllefteffect";

const Service = () => {
  return (
    <div id="service">
      <div
        className="about__row-container"
        style={{ display: "flex", flexDirection: "row" }}
      >
        <div className="about__row-img">
          <img src={serviceimg} alt="about-img" />
        </div>
        <div className="about__row-text">
          <ScrollReveal>
            <h1>
              Things <br /> we do
            </h1>
          </ScrollReveal>

          <Scrolllefteffect>
            <h3>We exist to create</h3>
          </Scrolllefteffect>

          <p className="about_text">
            Focus infographic venture business model canvas gamification
            ecosystem. Business plan gamification user experience low hanging
            fruit twitter. Metrics research & development market paradigm shift
            growth hacking disruptive user experience iPad social media angel
            investor alpha. Social proof lean startup alpha scrum project
            non-disclosure agreement.
          </p>
          <button type="button">
            <a href="#contact"> Get in Touch</a>
           
          </button>
        </div>
      </div>
    </div>
  );
};

export default Service;
